/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { EmailVerificationCodeRedeemRequest } from './model/emailVerificationCodeRedeemRequest';

export const apiAccountEmailVerificationRedeemCreate = (
  emailVerificationCodeRedeemRequest: EmailVerificationCodeRedeemRequest,
  signal?: AbortSignal
) => {
  return HTTP<void>({
    url: `/api/v7/account/email-verification/code/redeem/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: emailVerificationCodeRedeemRequest,
    signal,
  });
};

export const getApiAccountEmailVerificationRedeemCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>,
    TError,
    { data: EmailVerificationCodeRedeemRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>,
  TError,
  { data: EmailVerificationCodeRedeemRequest },
  TContext
> => {
  const mutationKey = ['apiAccountEmailVerificationRedeemCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>,
    { data: EmailVerificationCodeRedeemRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountEmailVerificationRedeemCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiAccountEmailVerificationRedeemCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>
>;
export type ApiAccountEmailVerificationRedeemCreateMutationBody =
  EmailVerificationCodeRedeemRequest;
export type ApiAccountEmailVerificationRedeemCreateMutationError = ErrorType<unknown>;

export const useApiAccountEmailVerificationRedeemCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>,
    TError,
    { data: EmailVerificationCodeRedeemRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>,
  TError,
  { data: EmailVerificationCodeRedeemRequest },
  TContext
> => {
  const mutationOptions = getApiAccountEmailVerificationRedeemCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
